import { useState, useEffect } from 'react';

const DISMISSED_KEY = 'oimy_install_dismissed';
const DISMISSED_UNTIL_KEY = 'oimy_install_dismissed_until';

export function useInstallPrompt(userLoggedIn = false) {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Only show to logged-in users who are past onboarding
    if (!userLoggedIn) return;
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return;
    if (localStorage.getItem(DISMISSED_KEY)) return;
    const until = localStorage.getItem(DISMISSED_UNTIL_KEY);
    if (until && Date.now() < parseInt(until)) return;

    const visited = localStorage.getItem('oimy_visited');
    const delay = visited ? 5000 : 30000;
    localStorage.setItem('oimy_visited', '1');

    const timer = setTimeout(() => setShowPrompt(true), delay);
    return () => clearTimeout(timer);
  }, [userLoggedIn]); // re-evaluates when login state changes

  const dismiss = (permanent = false) => {
    if (permanent) {
      localStorage.setItem(DISMISSED_KEY, '1');
    } else {
      localStorage.setItem(DISMISSED_UNTIL_KEY, String(Date.now() + 3 * 24 * 60 * 60 * 1000));
    }
    setShowPrompt(false);
  };

  return { showPrompt, dismiss };
}
